import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-site-pj',
  templateUrl: './site-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./site-pj.component.css']
})
export class SitePjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.site===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.site===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
